/**
 * Maximum length of the account-specific instructions for the chat agent
 * (Dave), measured on the raw markdown string a Super Admin saves — markup
 * characters count. Enforced in the editor UI and the backend. Bounds the
 * per-request token cost (~1.25k tokens).
 */
export const CHAT_AGENT_INSTRUCTIONS_MAX_LENGTH = 5000;
